import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import "../Custom/custom.scss";
import CheckoutBlank from "../checkout/checkoutBlank";
import { _Api } from "../common/api/_call";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import warrantyCard from "../../assets/images/pos/icons/warranty-w.png";
import Loading from "pos/common/module/Loading/Loading";
const Card = () => {
  const { t } = useTranslation();
  const generalsettings = useSelector((state) => state.app.generalsettings);
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const getCartClear = async () => {
    try {
      const postdata = {};
      let res = await _Api(postdata, `api/v1/POS/customOrder/cartClear`);
      if (res?.code === 200) {
        localStorage.removeItem("showcheckout");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    getCartClear();
  }, []);


  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
//   const location = useLocation();
// const [showLoading, setShowLoading] = useState(location.state?.fromClick ?? false);

// useEffect(() => {
//   if (!showLoading) return;
//   const timer = setTimeout(() => setShowLoading(false), 2500);
//   return () => clearTimeout(timer);
// }, []);

// if (showLoading) return <Loading />;

  return (
    <>
      <div className="main-body">
        <div className="main-body-row">
          <div className="main-body-row-left-col p-0">
            <div className="catalog-area bg-white page-menu-block">
              <div className="catalog-area-header-area detail-area-header">
                <div className="catalog-area-header-area-control">
                  <div className="catalog-area-header-area-control-left">
                    <h1 className="heading text-uppercase">{t("GIFT CARD")}</h1>
                  </div>
                  <div className="catalog-area-header-area-control-right">
                    <div
                      className={
                        parmissiondatashow?.pos_custom_order?.View
                          ? "custom-tooltip"
                          : "d-none"
                      }
                    >
                      <Link to="/app/pos/custom/customOrderDelivered">
                        <img
                          className="custom-order-img"
                          src={
                            base_assets +
                            "images/pos/icons/custom-order-icon.png"
                          }
                          alt=""
                        />
                        <span className="com-btn custom-tooltip-text">
                          {t("Custom Order")}
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="page-menu-block-inner bg-white">
                <h1 className="main-heading">{t("Select your option")}</h1>
                <div className="menu-block-row">
                  <div
                    className={
                      parmissiondatashow?.pos_custom_order?.View
                        ? "menu-block-row-col hover-effect"
                        : "d-none"
                    }
                  >
                    <Link
                      to="/app/pos/giftCard"
                      className="menu-block-row-col-a hover-effect-inner"
                    >
                      <span className="menu-block-row-col-a-img position-relative">
                        <img
                          className="hover-effect-inner-img hover-effect-inner-img-g"
                          style={{
                            filter:
                              "brightness(0) saturate(100%) invert(71%) sepia(47%) saturate(400%) hue-rotate(130deg) brightness(95%)",
                          }}
                          src={base_assets + "images/pos/icons/gift-card-w.png"}
                          alt=""
                        />
                        <img
                          className="hover-effect-inner-img hover-effect-inner-img-w"
                          src={base_assets + "images/pos/icons/gift-card-w.png"}
                          alt=""
                        />
                      </span>
                      <span className="menu-block-row-col-a-title">
                        {t("Gift Card")}
                      </span>
                    </Link>
                  </div>

                  {generalsettings?.data?.generalsetup?.warranty === "1" ? (
                    <div
                      className={
                        parmissiondatashow?.pos_custom_order?.View
                          ? "menu-block-row-col hover-effect"
                          : "d-none"
                      }
                    >
                      <Link
                        to="/app/pos/warrantyCard"
                        className="menu-block-row-col-a hover-effect-inner"
                      >
                        <span className="menu-block-row-col-a-img position-relative">
                          <img
                            className="hover-effect-inner-img hover-effect-inner-img-g"
                            src={warrantyCard}
                            alt=""
                          />
                          <img
                            className="hover-effect-inner-img hover-effect-inner-img-w"
                            src={warrantyCard}
                            alt=""
                            style={{ filter: "brightness(0) invert(1)" }}
                          />
                        </span>
                        <span className="menu-block-row-col-a-title">
                          {t("Warranty Card")}
                        </span>
                      </Link>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="main-body-row-right-col">
            <CheckoutBlank />
          </div>
        </div>
      </div>
    </>
  );
};

export default Card;
